<template>
  <div :class="elementClass">
    <b-col class="datepicker-start-col">
      <div class="label-wrapper">
        <label :for="filterId" :class="labelClass">{{ label }}</label>
        <div v-if="hasHovertip" class="hovertip-wrapper">
          <img
            v-if="hasHovertip"
            :id="getHovertipId"
            :src="hovertipSrc"
            alt="help"
            style="height: 0.75rem; margin-left: 0.5rem"
          />
          <b-popover
            v-if="hasHovertip"
            :target="getHovertipId"
            triggers="hover focus"
          >
            <template slot="title">
              {{ getHovertipTitle }}
            </template>
            {{ getHovertipText }}
          </b-popover>
        </div>
      </div>
      <datepicker
        typeable
        :class="inputClass"
        :clear-button="allowClear"
        :value="getValue"
        :required="elementRequired"
        @input="updateFilter"
        name="Last Updated After"
        :placeholder="placeholder"
        :format="format"
        :use-utc="true"
      />
    </b-col>

    <template v-if="dateBetween">
      <b-col class="datepicker-end-col">
        <div class="label-wrapper">
          <label v-if="dateBetween">{{ endLabel }}</label>
        </div>

        <datepicker
          typeable
          class="chemtracker-container-date-filter"
          :clear-button="allowClear"
          :value="endDateGetValue"
          :required="elementRequired"
          @input="handleEndDateUpdate"
          v-if="dateBetween"
          v-model="date2"
          :format="format"
          :use-utc="true"
        />
      </b-col>
    </template>
  </div>
</template>

<script>
// Note: babelPolyfill shows up as 'unused', but it's not.
// If we remove it we get "ReferenceError: regeneratorRuntime is not defined"
// JS errors on any page that uses this.
import babelPolyfill from "babel-polyfill";
import datepicker from "vuejs-datepicker";
import PathMapper from "../../lib/PathMapper";
import helpOutline from "../raft/help-Outline.svg";

export default {
  name: "DateFilter",
  data() {
    return {
      hovertipSrc: helpOutline,
      selected: "",
      date2: "",
    };
  },
  computed: {
    elementClass: function () {
      const classname = "datefilter form-group ";
      if (this.wrapperClass) {
        return classname + this.wrapperClass;
      }
      return classname;
    },
    filterId: function () {
      return this.id;
    },
    filterLabelId: function () {
      return this.id + "-label";
    },
    allowClear: function () {
      return !this.isRequired;
    },
    elementRequired: function () {
      return this.isRequired === true;
    },
    labelClass: function () {
      if (this.required) {
        return "form-required";
      }
      return "";
    },
    getHelpIconPath: function () {
      return PathMapper.getIconAssetPath("help.png", this.$isB4);
    },
    hasHovertip: function () {
      return this.hovertip;
    },
    getHovertipId: function () {
      return this.hovertip.id;
    },
    getHovertipTitle: function () {
      return this.hovertip.title;
    },
    getHovertipText: function () {
      return this.hovertip.text;
    },
  },
  components: {
    datepicker,
  },
  props: {
    id: { type: String, default: null },
    label: { type: String, default: null },
    endLabel: { type: String, default: null },
    format: { type: String, default: "yyyy-MM-dd" },
    updateMethod: { type: Function, default: null },
    getValue: { type: [Date, String], default: null },
    trackBy: { type: String, default: null },
    displayValue: { type: String, default: null },
    placeholder: { type: String, default: null },
    isRequired: { type: Boolean, default: false },
    hovertip: { type: Object, default: null },
    dateBetween: { type: Boolean, default: false },
    endDateUpdateMethod: { type: Function, default: null },
    endDateGetValue: { type: [Date, String], default: null },
    inputClass: { type: String, default: null },
    wrapperClass: { type: String, default: null },
    filterAction: { type: String, required: false },
    filterKey: { type: String, required: false },
  },
  methods: {
    updateFilter(value) {
      const differentStrings = (previousValue, newValue) =>
        (previousValue ?? "") !== (newValue ?? "");
      if (differentStrings(this.getValue, value)) {
        this.$emit("update-filter", {
          id: this.id,
          value: value,
          filterAction: this.filterAction,
          filterKey: this.filterKey,
        });
        if (this.updateMethod) {
          this.updateMethod(value);
        }
      }
    },
    handleEndDateUpdate(value) {
      const differentStrings = (previousValue, newValue) =>
        (previousValue ?? "") !== (newValue ?? "");
      if (differentStrings(this.endDateGetValue, value)) {
        this.$emit("update-filter", {
          id: this.id,
          value: value,
          filterAction: this.filterAction,
          filterKey: this.filterKey + "-end",
        });
        if (this.endDateUpdateMethod) {
          this.endDateUpdateMethod(value);
        }
      }
    },
  },
  mounted() {},
};
</script>

<style scoped>
:is(#raft-js, #raft-js-app) div.vdp-datepicker >>> input {
  margin: 0.125rem 0 0 0;
  width: calc(12.5rem * 0.9);
}

:is(#raft-js, #raft-js-app) div.datefilter >>> .label-wrapper {
  display: flex;
}

:is(#raft-js, #raft-js-app) .vdp-datepicker div {
  display: flex;
}
</style>
